const generalStyle = {
  options: {
    widgets: {
      Menu_preLoader: {
        type: 'Menu',
        renderOptions: {
          controlKey: 'preLoader',
        },
        options: {
          preLoader: {
            type: 'ImageUploader',
          },
          preLoaderSpinSpeed: {
            type: 'RangeNumber',
            data: {
              min: 0,
              max: 10,
              step: 1,
            },
          },
        },
      },
      Menu_themeStyles: {
        type: 'Menu',
        renderOptions: {
          controlKey: 'themeStyles',
        },
        options: {
          fontFamily: {
            type: 'SelectBox',
            data: {
              selectOptions: ['Roboto', 'Arial', 'Ubuntu', 'Poppins', 'Kanit', 'Montserrat'],
            },
          },
          primaryThemeColor: {
            type: 'HexColor',
          },
          secondaryThemeColor: {
            type: 'HexColor',
          },
          thirdThemeColor: {
            type: 'HexColor',
          },
          fourthThemeColor: {
            type: 'HexColor',
          },
          fifthThemeColor: {
            type: 'HexColor',
          },
          sixthThemeColor: {
            type: 'HexColor',
          },
          themeColorMode: {
            type: 'SelectBox',
            data: {
              selectOptions: ['dark', 'light'],
            },
          },
        },
      },
      Menu_globalThemeSettings: {
        type: 'Menu',
        renderOptions: {
          controlKey: 'globalThemeSettings',
        },
        options: {
          disabledStockLocations: {
            type: 'Modal',
            data: {
              type: 'StockLocations',
            },
          },
        },
      },
      Menu_searchSortSettings: {
        type: 'Menu',
        renderOptions: {
          controlKey: 'searchSortSettings',
        },
        options: {
          'searchSortSettings.sort': {
            type: 'SelectBox',
            data: {
              selectOptions: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
            },
          },
        },
      },
      Menu_brandSortSettings: {
        type: 'Menu',
        renderOptions: {
          controlKey: 'brandSortSettings',
        },
        options: {
          'brandSortSettings.sort': {
            type: 'SelectBox',
            data: {
              selectOptions: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
            },
          },
        },
      },
      Menu_categorySortSettings: {
        type: 'Menu',
        renderOptions: {
          controlKey: 'categorySortSettings',
        },
        options: {
          'categorySortSettings.sort': {
            type: 'SelectBox',
            data: {
              selectOptions: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
            },
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'generalStyle_1',
      name: 'generalStyle_1',
      type: 'generalStyle',
      data: {
        text: '',
        images: [],
      },
      customization: {
        preLoader: 'https://',
        preLoaderSpinSpeed: 0,
        fontFamily: 'Ubuntu',
        primaryThemeColor: '#FFF',
        secondaryThemeColor: '#FFF',
        thirdThemeColor: '#FFF',
        fourthThemeColor: '#FFF',
        fifthThemeColor: '#FFF',
        sixthThemeColor: '#FFF',
        themeColorMode: 'light',
        disabledStockLocations: [],
        'searchSortSettings.sort': '12',
        'categorySortSettings.sort': '12',
        'brandSortSettings.sort': '12',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/classic_marquee_placeholder.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
  ],
};
export default generalStyle;
